
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const StartupCTA = () => {
  const handleStartNow = () => {
    window.location.href = "https://app.upfixe.com";
  };

  return (
    <div className="rounded-lg bg-gradient-to-r from-blue-600 to-blue-700 p-8 text-white my-12">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-4">Launch Your Campaign in the Next 5 Minutes</h2>
        <p className="text-lg mb-8">
          Don't spend weeks planning. Start testing your market today and see which ideas have potential before your competitors do.
        </p>
        <div className="flex justify-center">
          <Button 
            size="lg" 
            className="bg-white text-blue-600 hover:bg-blue-50"
            onClick={handleStartNow}
          >
            Launch Campaign Now for Free <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
        <p className="mt-4 text-sm opacity-90">Launch in 5 minutes. No credit card required.</p>
      </div>
    </div>
  );
};

export default StartupCTA;
